/* eslint-disable no-unused-vars */
import axiosAuthenticated from '@/api/axios'

const urlBase = '/api/users'

const state = {
  userAddress: [],
  userData: {}
}

const getters = {
  userAddress: (state) => state.userAddress,
  userData: (state) => state.userData
}

const mutations = {
  SET_USER_ADDRESS(state, payload) {
    state.userAddress = payload
  },
  SET_USER_DATA(state, payload) {
    state.userData = payload
  }
}

const actions = {
  fetchUserAddress({ commit }) {
    axiosAuthenticated
      .get(`${urlBase}/get_address`)
      .then((res) => {
        commit('SET_USER_ADDRESS', res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  createUserAddress(context, { payload, vm }) {
    const data = new FormData()

    for (const key in payload) {
      data.append(key, payload[key])
    }

    axiosAuthenticated
      .post(`${urlBase}/create_address`, data)
      .then(() => {
        vm.dialogAddNewAddress = false

        context.dispatch('fetchUserAddress')
      })
      .catch((err) => {
        console.log(err)

        vm.addressWrongSnackbar = true
      })
  },
  async fetchUserData({ commit }) {
    try {
      const res = await axiosAuthenticated.get(`${urlBase}/get_user_data`)
      commit('SET_USER_DATA', res.data)
    } catch (err) {
      console.error(err)
    }
  },
  fetchUserDataForSettings(_context, { vm }) {
    axiosAuthenticated
      .get(`${urlBase}/get_user_data`)
      .then((res) => {
        const userData = res.data
        vm.firstName = userData.first_name
        vm.lastName = userData.last_name
        vm.country = userData.country
        vm.phone = userData.phone
        vm.email = userData.email
        vm.address = userData.address
      })
      .catch((err) => {
        console.log(err)
      })
  },
  async updateUserData(context, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    try {
      await axiosAuthenticated.post(`${urlBase}/update_user_data`, data)
      await context.dispatch('fetchUserData')
      await vm.$router.push('/user')
    } catch (err) {
      console.error(err)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
